const authorize = {
  path: 'authorize',
  component: resolve => require(['../../../components/pages/authorize'], resolve),
  redirect: 'authorize/bind',
  children: [{
    path: 'bind',
    component: resolve => require(['../../../components/pages/authorize/bind'], resolve)
  }]
}

export default authorize



// WEBPACK FOOTER //
// ./src/router/pages/authorize/index.js